export enum CreditCardFeeType {
    Percentage = 1,
    Fixed = 2
}

export const CreditCardFeeTypeLabel = {
    [CreditCardFeeType.Percentage]: 'Percentage',
    [CreditCardFeeType.Fixed]: 'Fixed Amount'
}